$(function () {
    var $form = $('#footerSubscribeForm');

    if (!$form.length) {
        return;
    }

    var $message = $('#footerSubscribeMessage');
    var genericErrorText = 'Something went wrong. Please try again.';
    var $submitBtn = $form.find('.footer-subscribe-btn');

    var isRecaptchaEnabled = $form.data('recaptcha-enabled') === '1' || $form.data('recaptcha-enabled') === 1;
    var siteKey = $form.data('recaptcha-site-key');
    var recaptchaWidgetId = null;
    var $recaptchaWidget = $('#footerRecaptchaWidget');
    var recaptchaRequested = false;

    function renderRecaptcha() {
        if (!window.grecaptcha || !window.grecaptcha.enterprise) {
            setTimeout(renderRecaptcha, 300);

            return;
        }

        window.grecaptcha.enterprise.ready(function () {
            try {
                recaptchaWidgetId = window.grecaptcha.enterprise.render('footerRecaptchaWidget', {
                    sitekey: siteKey,
                    action: 'subscribe',
                    callback: function (token) {
                        $('#footerRecaptchaToken').val(token);
                    },
                });
            } catch (e) {
                recaptchaWidgetId = null;
            }
        });
    }

    function revealRecaptcha() {
        if (recaptchaRequested) {
            return;
        }

        recaptchaRequested = true;

        $recaptchaWidget.prop('hidden', false);
        renderRecaptcha();
    }

    if (isRecaptchaEnabled && siteKey) {
        $('#footer_email').on('input', function () {
            if ($(this).val().trim() !== '') {
                revealRecaptcha();
            }
        });
    }

    function showMessage(text, isError) {
        $message
            .text(text)
            .removeClass('is-success is-error')
            .addClass(isError ? 'is-error' : 'is-success')
            .prop('hidden', false);
    }

    function resetRecaptcha() {
        if (recaptchaWidgetId === null || !window.grecaptcha || !window.grecaptcha.enterprise) {
            return;
        }

        try {
            window.grecaptcha.enterprise.reset(recaptchaWidgetId);
        } catch (e) {
            /* widget could not be reset; next submit will just fail validation again */
        }
    }

    $form.on('submit', function (e) {
        e.preventDefault();

        $submitBtn.prop('disabled', true);

        $.ajax({
            url: $form.attr('action'),
            method: 'POST',
            data: $form.serialize(),
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            dataType: 'json',
        }).done(function (response) {
            if (response && response.successful) {
                showMessage(response.message, false);
                $form[0].reset();
            } else {
                showMessage((response && response.message) || genericErrorText, true);
            }

            resetRecaptcha();
        }).fail(function () {
            showMessage(genericErrorText, true);
            resetRecaptcha();
        }).always(function () {
            $submitBtn.prop('disabled', false);
        });
    });
});
